// extracted by mini-css-extract-plugin
module.exports = {"fileCard":"FileToDownload_fileCard__20uIg","downloadIcon":"FileToDownload_downloadIcon__2xW1v","fileLink":"FileToDownload_fileLink__2vTcN"};